import { createFileRoute } from "@tanstack/react-router";
import SpravatoCaregivers from "@/pages/SpravatoCaregivers";
export const Route = createFileRoute("/spravato-for-caregivers")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SPRAVATO® for Caregivers | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Caregivers facing depression can find support with SPRAVATO® at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® for Caregivers | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Caregivers facing depression can find support with SPRAVATO® at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for treatment-resistant depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-for-caregivers",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-for-caregivers",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoCaregivers />;
}
